"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTooltips = exports.formatYAxes = exports.showNthTick = void 0;
var isInteger_1 = __importDefault(require("lodash/isInteger"));
var showNthTick = function (options, n) {
    return __assign(__assign({}, options), { scales: __assign(__assign({}, options.scales), { xAxes: options.scales.xAxes.map(function (axis) {
                axis.ticks = {
                    callback: function (item, index) {
                        if (!(index % n))
                            return item;
                    },
                    autoSkip: false,
                };
                axis.display = true;
                return axis;
            }) }) });
};
exports.showNthTick = showNthTick;
var formatYAxes = function (options) {
    if (options.scales && options.scales.yAxes) {
        return __assign(__assign({}, options), { scales: __assign(__assign({}, options.scales), { yAxes: options.scales.yAxes.map(function (axis) {
                    axis.ticks.callback = formatWithThousandSeperator;
                    return axis;
                }) }) });
    }
    return options;
};
exports.formatYAxes = formatYAxes;
var formatTooltips = function (options) {
    return __assign(__assign({}, options), { tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
                label: formatLabelWithThousandSeperator,
            },
        } });
};
exports.formatTooltips = formatTooltips;
var formatWithThousandSeperator = function (value) {
    if (value < 1000) {
        return formatDecimals(value);
    }
    return addThousandSeperators(value);
};
var formatLabelWithThousandSeperator = function (tooltipItems) {
    if (typeof tooltipItems.yLabel === 'string') {
        return tooltipItems.yLabel;
    }
    if (tooltipItems.yLabel < 1000) {
        return formatDecimals(tooltipItems.yLabel);
    }
    return addThousandSeperators(tooltipItems.yLabel);
};
var addThousandSeperators = function (value) {
    if (typeof value === 'string') {
        return value;
    }
    if (value > 1000) {
        if (!(0, isInteger_1.default)(value)) {
            value = Math.round(value);
        }
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    return value.toString();
};
var formatDecimals = function (value) {
    if (typeof value === 'string') {
        return value;
    }
    return (0, isInteger_1.default)(value)
        ? value.toString()
        : value.toFixed(2).replace('.', ',');
};
